export const newQuoteEmailTemplate = (props) => {
    // - dataValidation
    return `<div style="margin: 0em 5em 0em 5em; ">
    <h1 style="text-align: center;">Bottle Ordering Information (New Quote)</h1>
    <table style="width:100%;">
        <tr>
            <th style="width: 70%; text-align: left;">
                <h2 style="display:inline;">Client Information</h2>
            </th>
            <th style="width: 20%; text-align: right; margin-right: 5em">
                <p style="display: inline;">Date: ${props.date}</p>
            </th>
        </tr>
    </table>
    <table style="width:50%;">
        <tr>
            <th style="width:auto; text-align:left"><strong>Name of Submitter / Contact: </strong></th>
            <th style="width:auto; text-align:right;">${props.contact}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Company: </strong></th>
            <th style="width:auto; text-align:right;">${props.company}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Contact phone number: </strong></th>
            <th style="width:auto; text-align:right;">${props.phoneNumber}</th>
        </tr>
        <tr>
            <th style="width:auto; text-align:left"><strong>Contact email: </strong></th>
            <th style="width:auto; text-align:right;">${props.email}</th>
        </tr>
    </table>

    <h2>Testing / Analysis Information</h2>

    <table style="width:50%;">
        <tr>
            <th style="width:auto; text-align:left"><strong>Name of Project: </strong></th>
            <th style="width:auto; text-align:right;">${props.projectName}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Schedule Name(s): </strong></th>
            <th style="width:auto; text-align:right;">${props.scheduleNames}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Drinking Water analysis: </strong></th>
            <th style="width:auto; text-align:right;">${props.drinkingWater}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>PWS ID: </strong></th>
            <th style="width:auto; text-align:right;">${props.PWS}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Reporting Limits: </strong></th>
            <th style="width:auto; text-align:right;">${props.reportingLimits}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Specific testing method: </strong></th>
            <th style="width:auto; text-align:right;">${props.method}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Filtered in the field: </strong></th>
            <th style="width:auto; text-align:right;">${props.filtered}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Data Validation/QC Level: </strong></th>
            <th style="width:auto; text-align:right;">${props.dataValidation}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Parameter needs: </strong></th>
            <th style="width:auto; text-align:right;">${props.parameterNeeds}</th>
        </tr>
    </table>

    <h2>Quote Information</h2>

    <table style="width:50%;">
        <tr>
            <th style="width:auto; text-align:left"><strong>Is there a quote number: </strong></th>
            <th style="width:auto; text-align:right;">${props.hasQuoteNumber}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Quote Number: </strong></th>
            <th style="width:auto; text-align:right;">${props.quoteNumber}</th>
        </tr>
    </table>

    <h2>Shipping / Receiving Information</h2>

    <table style="width:50%;">
        <tr>
            <th style="width:auto; text-align:left"><strong>Receive order by: </strong></th>
            <th style="width:auto; text-align:right;">${props.receiveDate}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Receive Carrier: </strong></th>
            <th style="width:auto; text-align:right;">${props.receiveCarrier}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Receive Service Level: </strong></th>
            <th style="width:auto; text-align:right;">${props.receiveServiceLevel}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Shipping Address: </strong></th>
            <th style="width:auto; text-align:right;">${`${props.addressName}, ${props.addressStreet1}, ${props.addressStreet2} ${props.addressCity}, ${props.addressState} ${props.addressZip}`}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Residential address: </strong></th>
            <th style="width:auto; text-align:right;">${props.isResidential}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Send Carrier: </strong></th>
            <th style="width:auto; text-align:right;">${props.sendCarrier}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Send Service Level: </strong></th>
            <th style="width:auto; text-align:right;">${props.sendServiceLevel}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Need Return Label: </strong></th>
            <th style="width:auto; text-align:right;">${props.needReturnLabel}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Send back to lab date: </strong></th>
            <th style="width:auto; text-align:right;">${props.returnDate}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Will samples fly: </strong></th>
            <th style="width:auto; text-align:right;">${props.isFlying}</th>
        </tr>
    </table>
</div>
`
};

export const newOrderEmailTemplate = (props) => {
    const cleanValue = (value) => (value ? value : "");

    const renderSection = (title, rows) =>
    {
        const validRows = rows
                .map(row => ({ ...row, value: cleanValue(row.value) }))
                .filter(row => row.value.trim() !== "");

        if (validRows.length === 0) return ""; 

        return `
            <div style="border: 1px solid #ddd; border-radius: 8px; padding: 15px; margin-bottom: 20px;">
                <h2>${title}</h2>
                <table style="width:100%; border-collapse: collapse; border: 1px solid #ddd;">
                    ${validRows
                .map((row, index) => `
                            <tr style="background: ${index % 2 === 0 ? "#f9f9f9" : "#ffffff"};">
                                <th style="width: 250px; text-align:left; padding: 10px; border: 1px solid #ddd; background: #f1f1f1;">${row.label}</th>
                                <td style="text-align:left; padding: 10px; border: 1px solid #ddd;">${row.value}</td>
                            </tr>
                        `)
                .join("")}
                </table>
            </div>
        `;
    };

    const addressParts = [
        props.addressName ?? "",
        props.addressStreet1 ?? "",
        props.addressStreet2 ?? "",
        props.addressCity ?? "",
        props.addressState ?? "",
        props.addressZip ?? ""
    ].filter(part => part && part.trim() !== "");

    const formattedAddress = addressParts.length > 0 ? addressParts.join(", ") : "";

    const jsonData = {
        date: props.date ? new Date(props.date) : null,
        contact: props.contact,
        company: props.company,
        phoneNumber: props.phoneNumber,
        email: props.email,
        projectName: props.projectName,
        drinkingWater: props.drinkingWater,
        PWS: props.PWS,
        reportingLimits: props.reportingLimits,
        method: props.method,
        filtered: props.filtered,
        parameterNeeds: props.parameterNeeds,
        additionalInformation: props.additionalInformation,
        hasQuoteNumber: props.hasQuoteNumber,
        quoteNumber: props.quoteNumber,
        receiveDate: props.receiveDate ? new Date(props.receiveDate) : null,
        receiveCarrier: props.receiveCarrier,
        receiveServiceLevel: props.receiveServiceLevel,
        shippingAddress: formattedAddress,
        isResidential: props.isResidential,
        sendCarrier: props.sendCarrier,
        sendServiceLevel: props.sendServiceLevel,
        needReturnLabel: props.needReturnLabel,
        returnDate: props.returnDate ? new Date(props.returnDate) : null,
        location: props.location 
    };

    const content = JSON.stringify(jsonData, null, 4);
    const timestamp = new Date().toISOString().replace(/[-T:.Z]/g, "");
    const fileName = `order_${timestamp}_${props.projectName}.elibo`;

    return {
        html: `
            <div style="margin: 2em 10%; font-family: Arial, sans-serif; background: #f9f9f9; padding: 20px; border-radius: 8px;">
                <h1 style="text-align: center; color: #333;">Bottle Ordering Information (New Order)</h1>
            
                ${renderSection("Client Information", [
            { label: "Date", value: props.date },
            { label: "Name of Submitter / Contact", value: props.contact },
            { label: "Company", value: props.company },
            { label: "Contact Phone Number", value: props.phoneNumber },
            { label: "Contact Email", value: props.email }
        ])}

                ${renderSection("Testing / Analysis Information", [
            { label: "Name of Project", value: props.projectName },
            { label: "Drinking Water Analysis", value: props.drinkingWater },
            { label: "PWS ID", value: props.PWS },
            { label: "Reporting Limits", value: props.reportingLimits },
            { label: "Specific Testing Method", value: props.method },
            { label: "Filtered in the Field", value: props.filtered },
            { label: "Parameter Needs", value: props.parameterNeeds }
        ])}

                ${renderSection("Additional Information", [
            { label: "Additional Information", value: props.additionalInformation }
        ])}

                ${renderSection("Quote Information", [
            { label: "Is there a Quote Number?", value: props.hasQuoteNumber },
            { label: "Quote Number", value: props.quoteNumber }
        ])}

                ${renderSection("Shipping / Receiving Information", [
            { label: "Receive Order By", value: props.receiveDate },
            { label: "Receive Carrier", value: props.receiveCarrier },
            { label: "Receive Service Level", value: props.receiveServiceLevel },
            { label: "Shipping Address", value: formattedAddress },
            { label: "Residential Address", value: props.isResidential },
            { label: "Send Carrier", value: props.sendCarrier },
            { label: "Send Service Level", value: props.sendServiceLevel },
            { label: "Need Return Label", value: props.needReturnLabel },
            { label: "Send Back to Lab Date", value: props.returnDate },
        ])}
            </div>
        `,
        attachment: {
            fileName: fileName,
            content: content,  
            contentType: "application/json"
        }
    };
};

export const repeatOrderEmailTemplate = (props) => {
    return `<div style="margin: 0em 5em 0em 5em; ">
    <h1 style="text-align: center;">Bottle Ordering Information (Repeat Order)</h1>
    <table style="width:100%;">
        <tr>
            <th style="width: 70%; text-align: left;">
                <h2 style="display:inline;">Client Information</h2>
            </th>
            <th style="width: 20%; text-align: right; margin-right: 5em">
                <p style="display: inline;">Date: ${props.date}</p>
            </th>
        </tr>
    </table>
    <table style="width:50%;">
        <tr>
            <th style="width:auto; text-align:left"><strong>Name of Submitter / Contact: </strong></th>
            <th style="width:auto; text-align:right;">${props.contact}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Company: </strong></th>
            <th style="width:auto; text-align:right;">${props.company}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Contact phone number: </strong></th>
            <th style="width:auto; text-align:right;">${props.phoneNumber}</th>
        </tr>
        <tr>
            <th style="width:auto; text-align:left"><strong>Contact email: </strong></th>
            <th style="width:auto; text-align:right;">${props.email}</th>
        </tr>
    </table>

    <h2>Order Identifier</h2>

    <table style="width:50%;">
        <tr>
            <th style="width:auto; text-align:left"><strong>Order Identifier: </strong></th>
            <th style="width:auto; text-align:right;">${props.previousIdentifier}</th>
        </tr>
    </table>

    <h2>Shipping / Receiving Information</h2>

    <table style="width:50%;">
        <tr>
            <th style="width:auto; text-align:left"><strong>Receive order by: </strong></th>
            <th style="width:auto; text-align:right;">${props.receiveDate}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Receive Carrier: </strong></th>
            <th style="width:auto; text-align:right;">${props.receiveCarrier}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Receive Service Level: </strong></th>
            <th style="width:auto; text-align:right;">${props.receiveServiceLevel}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Shipping Address: </strong></th>
            <th style="width:auto; text-align:right;">${`${props.addressName}, ${props.addressStreet1}, ${props.addressStreet2} ${props.addressCity}, ${props.addressState} ${props.addressZip}`}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Residential address: </strong></th>
            <th style="width:auto; text-align:right;">${props.isResidential}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Send Carrier: </strong></th>
            <th style="width:auto; text-align:right;">${props.sendCarrier}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Send Service Level: </strong></th>
            <th style="width:auto; text-align:right;">${props.sendServiceLevel}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Need Return Label: </strong></th>
            <th style="width:auto; text-align:right;">${props.needReturnLabel}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Send back to lab date: </strong></th>
            <th style="width:auto; text-align:right;">${props.returnDate}</th>
        </tr>
        <hr />
        <tr>
            <th style="width:auto; text-align:left"><strong>Will samples fly: </strong></th>
            <th style="width:auto; text-align:right;">${props.isFlying}</th>
        </tr>
    </table>
</div>
`
};